import type { MovementType } from '@/types';

/** Conceptos disponibles al emitir un recibo. */
export const RECEIPT_CONCEPTS = [
  'Mensualidad',
  'Desarrollo',
  'Mantenimiento',
  'Servicio adicional',
  'Otro',
];

export interface FinanceCategoryGroup {
  type: MovementType;
  label: string;
  categories: string[];
}

export const FINANCE_CATEGORIES: FinanceCategoryGroup[] = [
  {
    type: 'INGRESO',
    label: 'Ingreso',
    categories: ['Mensualidad', 'Desarrollo', 'Mantenimiento', 'Servicio', 'Otro'],
  },
  {
    type: 'EGRESO',
    label: 'Egreso',
    categories: [
      'Software',
      'Hosting',
      'Servidores',
      'Publicidad',
      'Personal',
      'Equipamiento',
      'Otros',
    ],
  },
];

export function getCategoriesByType(type: MovementType): string[] {
  return FINANCE_CATEGORIES.find((group) => group.type === type)?.categories ?? [];
}